import { useState, Fragment, useMemo } from 'react';
import { CatTabs } from '@blocks-react/components/Tabs';
import { CatTab } from '@blocks-react/components/Tab';
import { CatTabPanel } from '@blocks-react/components/TabPanel';
import { CatDivider } from '@blocks-react/components/Divider';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { CatLayoutContainer } from '@blocks-react/components/LayoutContainer';
import { CatLayout } from '@blocks-react/components/Layout';
import { CatLayoutSection } from '@blocks-react/components/LayoutSection';
import ContactUsDealerInformationSection from './ContactUsDealerInformationSection';
import ContactUsCallUsSection from './ContactUsCallUsSection';
import { PAGE_BREAKPOINTS } from '@app/constants/commonConstants';
import { useBreakpoint } from '@app/hooks';
import ContactUsFormDescription from './ContactUsFormSection/ContactUsFormDescription';
import ContactUsFormNotification from './ContactUsFormSection/ContactUsFormNotification';
import ContactUsForm from './ContactUsFormSection/ContactUsForm';
import styles from './ContactUs.module.scss';
import cx from 'classnames';
import {
  finningUKDealerCode,
  ContactUsTabs,
  VARIANTS_MESSAGE_NOTIFICATION
} from './constants';

const ContactUsPage = () => {
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);
  const [t] = useTranslation();

  const dealerCode = useSelector(state => state.dealer?.dealerCode);

  const isFinningUKDealer = useMemo(() => {
    return dealerCode === finningUKDealerCode;
  }, [dealerCode]);

  const [inlineNotification, setInlineNotification] = useState({
    variant: '',
    show: false
  });

  const handleNotification = ({ variant, show }) => {
    setInlineNotification({
      ...inlineNotification,
      variant: variant,
      show: show
    });

    if (show) {
      window.scrollTo(0, 0);
    }
  };

  const handleCloseInlineNotification = () => {
    setInlineNotification({
      ...inlineNotification,
      show: false
    });
  };

  const contactUsFormComponent = tabAction => {
    return (
      <ContactUsForm
        onError={show =>
          handleNotification({
            variant: VARIANTS_MESSAGE_NOTIFICATION.ERROR,
            show
          })
        }
        onSuccess={show =>
          handleNotification({
            variant: VARIANTS_MESSAGE_NOTIFICATION.SUCCESS,
            show
          })
        }
        tabAction={tabAction}
      />
    );
  };

  return (
    <>
      <div className={styles['contactUsPage']}>
        <CatLayoutContainer>
          {inlineNotification.show && inlineNotification.variant && (
            <ContactUsFormNotification
              heading={
                inlineNotification.variant ===
                VARIANTS_MESSAGE_NOTIFICATION.ERROR
                  ? t('TECHNICAL_ISSUE')
                  : t('FORM_SUBMITTED')
              }
              body={
                inlineNotification.variant ===
                VARIANTS_MESSAGE_NOTIFICATION.ERROR
                  ? t('PLEASE_TRY_LATER')
                  : ''
              }
              variant={inlineNotification.variant}
              close={handleCloseInlineNotification}
            />
          )}
          <div
            className={cx(styles['contactUsPage__container'], {
              'pt-3 pt-lg-4 mt-3': !inlineNotification.show
            })}
          >
            <CatLayout break="faster">
              <CatLayoutSection>
                <div className={styles['contactUsPage__form-section']}>
                  <ContactUsFormDescription />
                  <div className={cx('mt-1', { 'pt-4': isFinningUKDealer })}>
                    {!isFinningUKDealer ? (
                      contactUsFormComponent(ContactUsTabs.CONTACT)
                    ) : (
                      <CatTabs behavior="full-width" variant="contrast">
                        <Fragment key=".0">
                          <CatTab>{t('CAT_CONTACT_US_TITLE')}</CatTab>
                          <CatTabPanel slot="panel">
                            {contactUsFormComponent(ContactUsTabs.CONTACT)}
                          </CatTabPanel>
                          <CatTab>{t('1294_ASK_AN_EXPERT')}</CatTab>
                          <CatTabPanel slot="panel">
                            {contactUsFormComponent(ContactUsTabs.EXPERT)}
                          </CatTabPanel>
                        </Fragment>
                      </CatTabs>
                    )}
                  </div>
                </div>
              </CatLayoutSection>
              <CatLayoutSection>
                <div className="mt-3 mb-4 pb-2 cat-u-hide-md">
                  <CatDivider />
                </div>
                <ContactUsDealerInformationSection />
              </CatLayoutSection>
            </CatLayout>
          </div>
        </CatLayoutContainer>
      </div>
    </>
  );
};

export default ContactUsPage;
